import { render, staticRenderFns } from "./CardError.vue?vue&type=template&id=5e788ad9&scoped=true&"
import script from "./CardError.vue?vue&type=script&lang=js&"
export * from "./CardError.vue?vue&type=script&lang=js&"
import style0 from "./CardError.vue?vue&type=style&index=0&id=5e788ad9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e788ad9",
  null
  
)

export default component.exports